import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as groupReducer from "containers/Group/reducer";

import Group from "components/Group/Group";

class GroupContainer extends React.PureComponent {
  render() {
    return <Group {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state, ownProps) => {
  const id = ownProps && ownProps.id;

  return {
    group: groupReducer.getGroup(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(GroupContainer);
